import { render, staticRenderFns } from "./deDataImpor.vue?vue&type=template&id=21f631fa&scoped=true&"
import script from "./deDataImpor.vue?vue&type=script&lang=js&"
export * from "./deDataImpor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f631fa",
  null
  
)

export default component.exports